var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    enableBackground: "new 0 0 56 56",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "none",
    width: 56,
    height: 56
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-26",
    fill: "#365568",
    d: "M34,20h10c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H34c-0.6,0-1-0.4-1-1l0,0 C33,20.4,33.4,20,34,20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-26-Copy",
    fill: "#365568",
    d: "M34,24h10c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H34c-0.6,0-1-0.4-1-1l0,0 C33,24.4,33.4,24,34,24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-26-Copy-2",
    fill: "#365568",
    d: "M34,28h10c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H34c-0.6,0-1-0.4-1-1l0,0 C33,28.4,33.4,28,34,28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-30",
    fill: "#DEEAEF",
    d: "M36,11h12.9v16.8c0,0-0.4-8.5-3.5-12.4C42.3,11.5,36,11,36,11z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    fill: "none",
    stroke: "#365568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: " 51,27.4 51,9 5,9 5,25.1 5,43 49.2,43 51,43 51,32.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-86-Copy",
    fill: "#7FBABA",
    d: "M19.5,31.7c6.7,0,7.3,2.9,7.3,2.9s-5,3.6-8.1,3.6s-6.4-0.7-7.5-0.7 C9,37.4,12.8,31.7,19.5,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-86",
    fill: "none",
    stroke: "#365568",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M8.6,35.6c0,0,3-5.2,8.9-5.2 s8.2,3,8.2,3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Combined-Shape",
    fill: "#7FBABA",
    cx: 18.4,
    cy: 24.7,
    rx: 3.7,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Combined-Shape-Copy",
    fill: "none",
    stroke: "#365568",
    strokeWidth: 2,
    cx: 18.4,
    cy: 23.8,
    rx: 3.8,
    ry: 3.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingAccountIcon);
export default __webpack_public_path__ + "static/media/setting-account-icon.a0377336f1bb2749c4514bafbf82d237.svg";
export { ForwardRef as ReactComponent };